// Funciones custom jQ

function ScrollTo(element, time) {
	$('html, body').animate({
		scrollTop: ($(element).offset().top-100)
	}, time);
}

function pulsate(control, i) {
  if(i >= 3) return;
  $(control).
    animate({opacity: 0.2}, 1000, 'linear').
    animate({opacity: 1}, 1000, 'linear', function(){
      pulsate(control,i)
    });
    i++;
}


document.addEventListener("DOMContentLoaded", function(){
	$('.preloader-background').delay(1700).fadeOut('slow');

	$('.preloader-wrapper')
		.delay(1700)
		.fadeOut();
});

(function($){

  $(function(){

	// MENU MATERIALIZE
		$(".button-collapse").sideNav();


	  // MAD-RIPPLE // (jQ+CSS)
    $(document).on("mousedown", "[data-ripple]", function(e) {

      var $self = $(this);

      if($self.is(".btn-disabled")) {
        return;
      }
      if($self.closest("[data-ripple]")) {
        e.stopPropagation();
      }

      var initPos = $self.css("position"),
          offs = $self.offset(),
          x = e.pageX - offs.left,
          y = e.pageY - offs.top,
          dia = Math.min(this.offsetHeight, this.offsetWidth, 100), // start diameter
          $ripple = $('<div/>', {class : "ripple",appendTo : $self });

      if(!initPos || initPos==="static") {
        $self.css({position:"relative"});
      }

      $('<div/>', {
        class : "rippleWave",
        css : {
          background: $self.data("ripple"),
          width: dia,
          height: dia,
          left: x - (dia/2),
          top: y - (dia/2),
        },
        appendTo : $ripple,
        one : {
          animationend : function(){
            $ripple.remove();
          }
        }
      });
    });


  }); // end of document ready
})(jQuery); // end of jQuery name space



// WEBPACK FOOTER //
// src/assets/js/init.js